module.exports = __webpack_public_path__ + "static/media/broadsword.47ecfebc.svg";